angular
	.module 'App.Repository'
	.factory 'LicenseRepository', ['BaseRepository', (BaseRepository) ->
		class LicenseRepository extends BaseRepository
			@resource = '/licenses'
			@isRestricted = true

			# Call /licenses/current to get current license for user
			findCurrent: ->
				return @find 'current'

			# Call /licenses/bundles to get available license bundles for user
			findBundles: ->
				return @find 'bundles'

			toggleRenewal: (model) ->
				return @post "#{model.id}/request_#{if model.deactivated then 're' else 'de'}activation"

			changeLicense: (id, model) ->
				return @post "#{id}/change", model

		return new LicenseRepository
	]
